export const buttonSizes = {
  sm: "h-8 w-8",
  default: "h-10 w-10",
  lg: "h-12 w-12",
  xl: "h-14 w-14"
} as const;

export const sizeVariants = {
  sm: "h-8 text-sm px-7",
  default: "h-10 text-base px-8",
  lg: "h-12 text-lg px-10",
  xl: "h-14 text-xl px-12"
} as const;

export const iconSizes = {
  sm: "h-3 w-3",
  default: "h-4 w-4",
  lg: "h-5 w-5",
  xl: "h-6 w-6"
} as const;

export const DEFAULT_PRESETS = [
  { label: 'Small', value: 25, category: 'Basic' },
  { label: 'Medium', value: 50, category: 'Basic' },
  { label: 'Large', value: 75, category: 'Basic' },
  { label: 'Extra Large', value: 100, category: 'Basic' },
] as const;